if (!customElements.get("share-button")) {
  customElements.define(
    "share-button",
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        this.mainDetailsToggle = this.querySelector("details");

        const fallbackPanel = this.querySelector(".share-button-fallback");

        this.elements = {
          shareButton: this.querySelector("button[data-share-native]"),
          shareSummary: this.querySelector("summary"),
          closeButton: fallbackPanel?.querySelector(".share-button-close"),
          successMessage: fallbackPanel?.querySelector('[id^="ShareMessage"]'),
          urlInput: fallbackPanel?.querySelector("input.field-input") || fallbackPanel?.querySelector("input"),
          copyButton: fallbackPanel?.querySelector(".share-button-copy"),
        };
        this.urlToShare = this.elements.urlInput
          ? this.elements.urlInput.value
          : document.location.href;

        const forceFallback = this.hasAttribute("data-force-fallback");

        if (navigator.share && !forceFallback && this.elements.shareButton) {
          if (this.mainDetailsToggle) this.mainDetailsToggle.setAttribute("hidden", "");
          this.elements.shareButton.classList.remove("hidden");
          this.elements.shareButton.addEventListener("click", () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else if (this.mainDetailsToggle) {
          this.mainDetailsToggle.addEventListener("toggle", this.toggleDetails.bind(this));
          this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
          if (this.elements.copyButton) {
            this.elements.copyButton.addEventListener("click", (event) => {
              event.preventDefault();
              this.copyToClipboard();
            });
          }
          if (this.elements.closeButton) {
            this.elements.closeButton.addEventListener("click", (event) => {
              event.preventDefault();
              this.close();
            });
          }
        }
      }

      onFocusOut() {
        setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        });
      }

      onDocumentClick(event) {
        if (!this.mainDetailsToggle?.open) return;
        if (this.contains(event.target)) return;
        this.close();
      }

      onDocumentKeydown(event) {
        if (event.key !== "Escape" || !this.mainDetailsToggle?.open) return;
        event.preventDefault();
        this.close();
        this.elements.shareSummary?.focus();
      }

      toggleDetails() {
        const isOpen = this.mainDetailsToggle.open;
        this.classList.toggle("is-share-open", isOpen);

        if (this.elements.shareSummary) {
          this.elements.shareSummary.setAttribute("aria-expanded", isOpen ? "true" : "false");
        }

        if (isOpen) {
          window.setTimeout(() => {
            document.addEventListener("click", this.onDocumentClick);
          }, 0);
          document.addEventListener("keydown", this.onDocumentKeydown);
          return;
        }

        document.removeEventListener("click", this.onDocumentClick);
        document.removeEventListener("keydown", this.onDocumentKeydown);

        if (this.elements.successMessage) {
          this.elements.successMessage.classList.add("hidden");
          this.elements.successMessage.textContent = "";
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.classList.add("hidden");
        }
      }

      copyToClipboard() {
        const input = this.elements.urlInput;
        if (!input) return;

        const text = input.value;
        const onSuccess = () => {
          if (this.elements.successMessage) {
            this.elements.successMessage.classList.remove("hidden");
            this.elements.successMessage.textContent =
              window.accessibilityStrings?.shareSuccess || "Link copied to clipboard";
          }
          if (this.elements.closeButton) {
            this.elements.closeButton.classList.remove("hidden");
          }
        };

        if (navigator.clipboard?.writeText) {
          navigator.clipboard.writeText(text).then(onSuccess).catch(() => {
            this.fallbackCopy(text, input, onSuccess);
          });
          return;
        }

        this.fallbackCopy(text, input, onSuccess);
      }

      fallbackCopy(text, input, onSuccess) {
        input.removeAttribute("readonly");
        input.focus();
        input.select();
        input.setSelectionRange(0, text.length);

        try {
          document.execCommand("copy");
          onSuccess();
        } catch (error) {
          console.error(error);
        }

        input.setAttribute("readonly", "");
      }

      close() {
        if (!this.mainDetailsToggle?.hasAttribute("open")) return;
        this.mainDetailsToggle.removeAttribute("open");
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    },
  );
}
